// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import {
  FulfillmentOrder,
  fulfillmentOrderSchema,
} from '@/fulfillment/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the cancel fulfillment order API endpoint.
 */
const cancelFulfillmentOrderResponseSchema = z.object({
  data: fulfillmentOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Cancels an existing fulfillment order with the specified reason.
 *
 * @param fulfillmentKey - The key of the fulfillment order to cancel
 * @param reason - The reason for cancellation
 * @returns The cancelled fulfillment order
 */
export async function cancelFulfillmentOrder(
  fulfillmentKey: string,
  reason: string
): Promise<FulfillmentOrder> {
  const url = `/v1/fulfillment/${fulfillmentKey}/cancel`;
  const response = await api.post(url, { cancellationReason: reason });

  const { data } = await parseResponse(
    cancelFulfillmentOrderResponseSchema,
    response.data,
    {
      schemaName: 'CancelFulfillmentOrder',
      endpoint: url,
    }
  );
  return data;
}
